import React from 'react';
import { useNavigate } from 'react-router-dom';

import BackIcon from '@mui/icons-material/ArrowBackIosNew';
import { Paper, Typography } from '@mui/material';

import ErrorImg from 'assets/images/404.webp';
import PrimaryBtn from 'components/UI/Buttons';
import SectionHeader from 'components/layout/SectionHeader';

const ErrorPage = () => {
  const navigate = useNavigate();
  return (
    <>
      <SectionHeader text="Error 404" button={null} />
      <Paper
        sx={{
          px: 5,
          py: 4,
          borderRadius: '20px',
          display: 'flex',
          flexDirection: 'column',
          width: { xs: '100%', lg: '650px' },
        }}
      >
        <Typography variant="h2" mb={2}>
          Oops... La página que buscas no existe
        </Typography>
        <img src={ErrorImg} alt="Error" style={{ width: 'min(600px, 98%)' }} />
        <PrimaryBtn onClick={() => navigate('/')} sx={{ mt: 6, width: '200px' }} startIcon={<BackIcon />}>
          Volver al Inicio
        </PrimaryBtn>
      </Paper>
    </>
  );
};

export default ErrorPage;
